<template>
  <div>
    <Loader v-if="loading"></Loader>
    <div class="wrraper" v-else>
      <!-- Start Breadcrumb -->
      <Breadcrumb
        :items="items"
        :show_print="true"
        :excelFile="true"
        :excelData="excelData"
      />
      <!-- End Breadcrumb -->
      <!-- start of searchSection  -->
      <SearchSection
        @filterTable="searchTable"
        pageTitle="تنفيذ شغل المؤسسات"
      ></SearchSection>
      <!-- end of searchSection  -->

      <!--Start Statistics Card-->
      <div class="row fadeIn">
          <div class="col-md-3" v-for="item in rowsWithTotalPaid" :key="item.id" @click="scrollToEnterprise(item.id)" style="cursor: pointer;">
          <stats-card
            :icon="item.works && item.works.length > 0 && item.works.every(work => work.status === 'confirmed') ? 'fal fa-check' : 'fal fa-hourglass-half'"
            :title="item.name"
            :withoutIcon="true"
            :completed="item.works.filter(work => work.status === 'confirmed').length"
            :pending="item.works.filter(work => work.status === 'pending').length"
            :saved="item.works.filter(work => work.is_saved).length"
            :total="item.works.length"
            :completedAmount="item.works.filter(work => work.status === 'confirmed').reduce((sum, work) => sum + Number(work.paid || 0), 0)"
            :pendingAmount="item.works.filter(work => work.status === 'pending').reduce((sum, work) => sum + Number(work.paid || 0), 0)"
            :number="Number(item.totalPaid).toLocaleString()"
            :color="item.works && item.works.length > 0 && item.works.every(work => work.status === 'confirmed') ? '#080' : '#525e6e'"
            :bgColor="'transparent'"
          ></stats-card>
        </div>
      </div>
      <!--End Statistics Card-->

      <!-- notFound  -->
      <Loader v-if="lodaing" class="sub-loader"></Loader>
      <div v-else>
        <Notfound v-if="!searchItems"></Notfound>
        <div v-else>
          <!-- Start Statistics Card-->
          <ul class="all-state-count">
            <li>
              <div class="state-count">
                <span>عدد عملاء تنفيذ شغل المؤسسات:</span>
                <span>{{ table_length }}</span>
              </div>
            </li>
          </ul>
          <!-- End Statistics Card-->

          <!-- Start Main Section -->
          <main class="table-print main-table">
            <!-- start of  header of printSection  -->
            <PrintHead
              :title="'عملاء تنفيذ شغل المؤسسات'"
              :number="table_length"
            ></PrintHead>
            <!-- end of header of printSection  -->
            <div
              v-for="i in rows"
              :key="i.id"
              :id="'enterprise-' + i.id"
              :class="companySearch ? 'border-tables' : ''"
            >
              <div 
                :class="[
                  !companySearch ? 'user-companies-tables' : '',
                  (activeTargetId === i.id) ? 'active-enterprise-bg' : ''
                ]"
              >
                <div class="user-name" v-if="companySearch == false">
                  <span> Enterprice Name </span>
                  <p
                    @click="calculate(i.amount)"
                    style="cursor: pointer; font-size: 15px; color: red; display: flex; flex-direction: column; align-items: center; gap: 0px;"
                  >
                    {{ i.name }}
                    <span
                      v-if="i.works && i.works.length > 0"
                      @click.stop="toggleTableCollapse(i.id)"
                      :class="['collapse-icon', collapsedTables[i.id] ? 'collapsed' : 'expanded']"
                    >
                      <v-icon>
                        far fa-chevron-double-down
                      </v-icon>
                    </span>
                  </p>
                </div>
                <v-data-table
                  class="thumb table_company enterprise_style"
                  :headers="headers"
                  :items="getTableItems(i)"
                  :loading="lodaing"
                  :loading-text="$t('table.loadingData')"
                  v-model="selected"
                  :single-select="singleSelect"
                  item-key="id"
                  :items-per-page="getTableItems(i).length"
                  hide-default-footer
                  :expanded="expanded"
                >
                  <!-- expanded section  -->
                  <template v-slot:[`item.index`]="{ index }">
                    {{ index + 1 }}
                  </template>
                  <template v-slot:[`item.company.name`]="slotData">
                    <button type="button" @click="columnClick(slotData)">
                      {{ slotData.item.company.name }}
                    </button>
                  </template>
                  <template v-slot:[`item.reference`]="{ item }">
                    <span v-if="item.reference"> {{ item.reference }} </span>
                    <span v-else> ----- </span>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div class="pdf-file text-left d-flex align-items-center">
                        <div class="checked ml-2">
                          <v-chip color="green" rounded v-if="item.is_saved"
                            ><i class="fal fa-check"></i
                          ></v-chip>
                        </div>
                        <div class="text flex-grow-1">
                          <div class="sub">
                            <div class="items">
                              <p>Amount</p>
                              <p>{{ item.paid }}</p>
                            </div>
                            <div class="items">
                              <p>Name</p>
                              <p>{{ item.company.name }}</p>
                            </div>
                            <div class="items bagItems">
                              <p>Address</p>
                              <p>{{ item.company.address }}</p>
                            </div>
                            <div class="items">
                              <p>A/C NO</p>
                              <p>{{ item.company.account_number }}</p>
                            </div>
                            <div class="items">
                              <p>SWIFT CODE</p>
                              <p>{{ item.company.swift_number }}</p>
                            </div>
                            <div class="items bagItems">
                              <p>REFERENCE NO</p>
                              <p v-if="item.reference">{{ item.reference }}</p>
                              <p v-else>-----</p>
                            </div>
                            <div class="items">
                              <p>BANK NAME</p>
                              <p>{{ item.company.bank.name }}</p>
                            </div>
                            <div class="items">
                              <p>Product</p>
                              <p>{{ item.company.products[0].name }}</p>
                            </div>
                            <div class="items bagItemsNew">
                              <p>البنك المنفذ</p>
                              <p>{{ item.executed_bank_name }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </template>
                  <!-- Select no data State -->
                  <template v-slot:no-data>
                    <!-- Company has works but table is collapsed -->
                    <div class="no-data-collapsed" v-if="i.works && i.works.length && collapsedTables[i.id]">
                      <p>
                        إجمالي المبلغ:
                        {{
                          i.works
                            .reduce((sum, work) => sum + Number(work.paid || 0), 0)
                            .toLocaleString()
                        }}
                        {{ i.works[0].currency }}
                      </p>
                      <p class="completed">
                        مكتمل ({{ i.works.filter(work => work.status === 'confirmed').length }})
                      </p>
                      <p :class="{'pending': i.works.filter(work => work.status === 'pending').length == 0, 'pending_red': i.works.filter(work => work.status === 'pending').length > 0 }">
                        قيد الانتظار ({{ i.works.filter(work => work.status === 'pending').length }})
                      </p>
                    </div>

                    <!-- Truly no data case -->
                    <span v-else>
                      {{ $t("table.noData") }}
                    </span>
                  </template>

                  <!-- Text Number -->
                  <template v-slot:[`item.companyLength`]="{ item }">
                    <span style="width: 100%; height: 100%">{{
                      item.company.name.length
                    }}</span>
                  </template>

                  <!-- created at -->
                  <template v-slot:[`item.created_at`]="{ item }">
                    <span
                      >{{ item.created_at }} <br />
                      {{ item.time_at }}</span
                    >
                  </template>

                  <!-- Status -->
                  <template v-slot:[`item.paid`]="{ item }">
                    <!-- {{ Number(item.paid).toLocaleString() }} {{ item.currency }} -->
                    <button
                      type="button"
                      @click="totalAmount(item, i)"
                      style="width: 100%; height: 100%"
                      :class="{
                        checkItem: allCalcItems.includes(item),
                      }"
                    >
                      {{ Number(item.paid).toLocaleString() }}
                      {{ item.currency }}
                    </button>
                  </template>
                  <!-- Select -->
                  <template v-slot:[`header.selected`]>
                    <span>حدد</span>
                    <!-- <v-simple-checkbox
                      class="ma-0 pa-0"
                      :value="isAllSelected(i.works)"
                      @click.stop="toggleSelectAll(i.works)"
                    /> -->
                  </template>
                  <template v-slot:[`item.selected`]="{ item }">
                    <v-simple-checkbox
                      class="ma-0 pa-0 check_style"
                      :value="item.is_saved"
                      @click.stop="toggleSelect(item)"
                    />
                  </template>
                  <!-- Select row field -->
                  <template v-slot:[`item.status`]="{ item }">
                    <v-chip
                      color="#d7c100"
                      class="mr-1"
                      v-if="item.status == 'pending'"
                    >
                      Pending
                    </v-chip>
                    <v-chip
                      color="green"
                      class="mr-1"
                      v-if="item.status == 'confirmed'"
                    >
                      Confirmed
                    </v-chip>
                    <v-chip
                      color="red"
                      class="mr-1"
                      v-if="item.status == 'refused'"
                    >
                      Refused
                    </v-chip>
                  </template>
                  <!-- Confirm-->
                  <template v-slot:[`item.confirm`]="{ item }">
                    <div
                      class="_actions actions2"
                      v-if="item.status == 'pending'"
                    >
                      <button
                        type="button"
                        class="accept confirm_btn"
                        @click="acceptCompany(item.id)"
                      >
                        <i class="far fa-check"></i>
                      </button>
                      <button
                        type="button"
                        class="reject confirm_btn"
                        @click="rejectCompany(item.id)"
                      >
                        <i class="far fa-times"></i>
                      </button>
                    </div>
                    <span v-if="item.status != 'pending'">-----</span>
                  </template>
                  <!-- Select actions-->
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="_actions">
                      <!-- <v-icon class="edit" small @click="editItem(item)">
                        fal fa-edit
                      </v-icon> -->
                      <v-icon class="delete" small @click="deleteItem(item)">
                        fal fa-trash
                      </v-icon>
                    </div>
                  </template>
                  <!-- Confirm-->
                  <template v-slot:[`item.pdf_file`]="{ item }">
                    <button
                      type="button"
                      @click="generateReport(item)"
                      style="font-size: 20px"
                    >
                      <i class="fal fa-download"></i>
                    </button>
                  </template>

                  <!-- ======================== Start Top Section ======================== -->
                  <template v-slot:top>
                    <!-- Delete dialog -->
                    <v-dialog v-model="dialogDelete" max-width="500px">
                      <v-card>
                        <v-card-title class="text-h5 justify-center">{{
                          $t("table.deletedialog.areYouSure")
                        }}</v-card-title>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="#1B5E20" @click="deleteItemConfirm"
                            >{{ $t("table.deletedialog.ok") }}
                            <span
                              class="btn_loader_model"
                              v-if="loadingBtnDialog"
                            ></span
                          ></v-btn>
                          <v-btn
                            color="#F44336"
                            @click="dialogDelete = false"
                            >{{ $t("table.deletedialog.cancel") }}</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <!-- Add & Delete -->
                  </template>
                  <!-- ======================== End Top Section ======================== -->
                </v-data-table>
              </div>
              <!-- =========== Add Total After Every Company =========-->
              <div class="total-of-client" v-if="i.totalPerClient != 0">
                <p>
                  <bdi>
                    All Total Amounts for <span>" {{ i.name }} " : </span>
                    <span dir="rtl">
                      {{
                        parseFloat(
                          Number(i.totalPerClient).toFixed()
                        ).toLocaleString()
                      }}
                      {{ i.works[0].currency }}
                    </span>
                  </bdi>
                </p>
              </div>
              <!-- =========== Add Total After Every Company =========-->
              <transition name="slide-fade" mode="out-in">
                <div
                  class="calculater"
                  v-if="
                    calculater.amount ==
                    parseFloat(Number(i.amount).toFixed()).toLocaleString()
                  "
                >
                  <button class="close" @click="calculater.amount = null">
                    <i class="fas fa-times"></i>
                  </button>
                  <div class="row justify-content-between">
                    <div class="col-lg-12 py-0">
                      <div class="divider">
                        <h4>حاسبة العميل</h4>
                        <hr
                          role="separator"
                          aria-orientation="horizontal"
                          class="v-divider theme--light"
                        />
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          disabled
                          v-model="calculater.amount"
                        />
                        <label for="name_input" class="form-label"
                          >المبلغ
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          step="any"
                          class="form-control"
                          v-model="calculater.mulit"
                        />
                        <label for="name_input" class="form-label">ضرب </label>
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          class="form-control"
                          v-model="calculater.divide"
                        />
                        <label for="name_input" class="form-label">قسمة </label>
                      </div>
                    </div>
                    <div class="col-lg-3 py-0">
                      <div class="input_wrapper top_label">
                        <input
                          type="text"
                          disabled
                          class="form-control"
                          v-model="calculaterAll"
                        />
                        <label for="name_input" class="form-label"
                          >الإجمالي
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </main>
          <!-- End Main Section -->
        </div>
      </div>

      <!-- Start Image_Model -->
      <base-model
        @closeModel="model_1.show_model = false"
        :show="model_1.show_model"
      >
        <div class="image">
          <img
            v-if="model_1.model_img_src"
            :src="model_1.model_img_src"
            alt="..."
          />
        </div>
      </base-model>
      <!-- End Image_Model -->
    </div>
    <div class="info-pill" v-if="calcResult">
      <p>
        All Total Amounts :
        <span :class="{ redColor: calcResult < 0 }"
          >{{ parseFloat(calcResult).toLocaleString() }}
          <i class="fal fa-coins"></i
        ></span>
      </p>
    </div>

    <!--Equation-->
    <div class="equation-wrapper" v-if="false">
      <div class="equation-content">
        <div class="main_title text-center">
          <h4>معادلة حساب الفرق</h4>
        </div>
        <form @submit.prevent="addToRecords">
          <div class="input_wrapper top_label equation-input">
            <input
              type="number"
              step="any"
              class="form-control"
              v-model.trim="data.totalAmount"
              readonly
            />
            <label for="name_input" class="form-label"> المبلغ الاجمالي </label>
          </div>
          <div class="math_mark">×</div>
          <div class="rate_calc">
            (
            <div class="input_wrapper top_label equation-input">
              <input
                type="number"
                step="any"
                class="form-control"
                v-model.trim="data.client_rate"
              />
              <label for="name_input" class="form-label"> ريت العميل </label>
            </div>
            <div class="math_mark">-</div>
            <div class="input_wrapper top_label equation-input">
              <input
                type="number"
                step="any"
                class="form-control"
                v-model.trim="data.bank_rate"
              />
              <label for="name_input" class="form-label"> ريت البنك </label>
            </div>
            )
          </div>
          <div class="math_mark">=</div>
          <div class="input_wrapper top_label equation-input">
            <input
              type="number"
              step="any"
              class="form-control"
              v-model.trim="data.subtraction"
              readonly
            />
            <label for="name_input" class="form-label"> الفرق </label>
          </div>
          <div class="text-center py-0">
            <button class="button_style_1">تسجيل</button>
          </div>
        </form>
      </div>
    </div>
    <!--Equation-->

    <!--Recored Table-->
    <main class="main-table my-4" v-if="false">
      <v-data-table
        class="thumb row-pointer"
        :headers="headers_amount"
        :items="last_amount"
        :loading="lodaing_amount"
        :loading-text="$t('table.loadingData')"
        v-model="selected"
        :single-select="singleSelect"
        item-key="id"
        :items-per-page="last_amount.length"
        hide-default-footer
      >
        <!-- ================== You Can use any slots you want ================== -->
        <!-- ====== Select row field ====== -->
        <!-- Select no data State -->
        <template v-slot:no-data>
          {{ $t("table.noData") }}
        </template>
        <template v-slot:[`item.index`]="{ index }">
          {{ index + 1 }}
        </template>
        <!-- Select actions-->
        <template v-slot:[`item.total_price`]="{ item }">
          <span v-if="item.total_price < 0" class="redColor">
            {{ Number(item.total_price).toLocaleString() }}
          </span>
          <span v-else-if="item.total_price > 0" class="greenColor">
            {{ Number(item.total_price).toLocaleString() }}
          </span>
          <span v-else>
            {{ Number(item.total_price).toLocaleString() }}
          </span>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ item.day }} - {{ item.date }} - {{ item.time }}
        </template>
        <template v-slot:[`item.details`]="{ item }">
          <v-icon class="show" small @click="showCollectBalance(item)">
            fal fa-eye
          </v-icon>
        </template>
        <!-- Select actions-->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="_actions">
            <v-icon class="delete" small @click="deleteItem(item)">
              fal fa-trash
            </v-icon>
          </div>
        </template>
        <template v-slot:[`item.confirm`]>
          <div class="_actions actions2">
            <button type="button" class="confirm_btn normal">
              <i class="far fa-check"></i>
            </button>
          </div>
        </template>
        <!-- ======================== Start Top Section ======================== -->
        <template v-slot:top>
          <!-- Delete dialog -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5 justify-center">{{
                $t("table.deletedialog.areYouSure")
              }}</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1B5E20" @click="deleteItemConfirm"
                  >{{ $t("table.deletedialog.ok") }}
                  <span class="btn_loader_model" v-if="loadingBtnDialog"></span
                ></v-btn>
                <v-btn color="#F44336" @click="dialogDelete = false">{{
                  $t("table.deletedialog.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <!-- ======================== End Top Section ======================== -->
      </v-data-table>
    </main>
    <!--Recored Table-->

    <!-- pdf file  -->
    <section class="pdf-print">
      <div class="pdf-file text-left">
        <div class="text">
          <h3>Enterprise job execution data</h3>
          <div class="sub">
            <div class="items">
              <p>Enterprise Bank Account</p>
              <p>{{ pdfContent.enterprice }}</p>
            </div>
            <div class="items">
              <p>Enterprise Rate</p>
              <p>{{ pdfContent.enterpriseRate }}</p>
            </div>
          </div>
          <div class="sub">
            <div class="items">
              <p>Client Name</p>
              <p>{{ pdfContent.clientName }}</p>
            </div>
          </div>

          <div class="sub">
            <div class="items">
              <p>Product</p>
              <p>{{ pdfContent.products }}</p>
            </div>
            <div class="items">
              <p>Name</p>
              <p>{{ pdfContent.fileName }}</p>
            </div>
            <div class="items">
              <p>BENEFICIARY ADDRESS</p>
              <p>{{ pdfContent.address }}</p>
            </div>
            <div class="items">
              <p>A/C NO</p>
              <p>{{ pdfContent.iban }}</p>
            </div>

            <div class="items">
              <p>SWIFT CODE</p>
              <p>{{ pdfContent.swift }}</p>
            </div>
            <div class="items" v-if="pdfContent.refNum">
              <p>REFERENCE NO</p>
              <p>{{ pdfContent.refNum }}</p>
            </div>
            <div class="items">
              <p>BANK NAME</p>
              <p>{{ pdfContent.bankName }}</p>
            </div>
          </div>

          <div class="sub">
            <div class="items">
              <p>Amount</p>
              <p>{{ pdfContent.amount }}</p>
            </div>
            <div class="items">
              <p>Transfer Date</p>
              <p>{{ pdfContent.created_at }}</p>
            </div>
            <div class="items">
              <p>Transfer Status</p>
              <p v-if="pdfContent.status == 'pending'">Pending</p>
              <p v-if="pdfContent.status == 'confirmed'">Confirmed</p>
              <p v-if="pdfContent.status == 'refused'">Refused</p>
              <p v-if="pdfContent.status == 'finished'">Finished</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- Return to Top Button -->
    <transition name="fade-bounce">
      <button v-show="showScrollTop" class="return-to-top" @click="scrollToTop">
        <i class="fal fa-chevron-up"></i>
      </button>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import StatsCard from "./../../../components/Charts/ChartComponent.vue";
import SearchSection from "@/components/Search/enterpriseAction";
export default {
  components: {
    StatsCard,
    SearchSection,
  },

  data() {
    return {
      activeTargetId: null,
      showScrollTop: false,
      // loadingBtnDialog
      loadingBtnDialog: false,
      // search
      searchItems: null,
      searchCompany: null,
      // loader
      loading: true,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: "كل تنفيذات شغل المؤسسات",
          disabled: true,
          href: "",
        },
      ],

      // ========== Statistics
      statisticsItems: [
        {
          id: 1,
          icon: "fal fa-images",
          title: "تنفيذ شغل المؤسسات",
          number: "1",
        },
      ],

      // ========== dialog Status
      dialogShow: false,
      itemToShow: null,
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Filter
      show_filter: false,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      //Data
      data: {
        client_rate: null,
        bank_rate: null,
        totalAmount: null,
        subtraction: null,
      },

      // ========== Body Section
      calories: "",

      // ========== Your Data
      rows: [], // injected in created
      allWorks: [],
      allCalcItems: [],
      calcResult: 0,

      //========Recored Table
      last_amount: [],
      lodaing_amount: false,

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // Custom Modal Data

      // ========== Loding
      lodaing: false,
      table_length: null,
      calculater: {
        amount: null,
        mulit: null,
        divide: 1,
      },
      // pdf
      pdfContent: {
        fileName: null,
        enterprice: null,
        enterpriseRate: null,
        enterpriseTotal: null,
        clientName: null,
        country: null,
        address: null,
        iban: null,
        refNum: null,
        bankName: null,
        swift: null,
        products: null,
        amount: null,
        created_at: null,
        status: null,
      },
      companySearch: false,
      expanded: [],
      collapsedTables: {}, // Track collapsed state for each table by item id
      // excel data
      excelData: {
        name: " تنفيذ شغل المؤسسات",
        items: null,
        json_fields: {
          "Enterprice Name": {
            field: "name",
            callback: (value) => {
              var target = this.rows.find((ele) => {
                return ele.name == value;
              });
              var theLength = target.works.length;
              return (
                `<table><tbody><tr><td style='text-align: center; vertical-align: middle;' rowspan='${theLength}'>` +
                value +
                "</td></tr></tbody></table>"
              );
            },
          },
          "Total amount": {
            field: "works",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" +
                    Number(val.paid).toLocaleString() +
                    "</td></tr>" +
                    "</tbody></table>";
                } else {
                  finalVal +=
                    "<tr><td>" +
                    Number(val.paid).toLocaleString() +
                    "</td></tr>";
                }
              });
              return finalVal;
            },
          },
          "Company Name": {
            field: "works",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" +
                    val.company.name +
                    "</td></tr>" +
                    "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.company.name + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
          "Client Name": {
            field: "works",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" +
                    val.customer.name +
                    "</td></tr>" +
                    "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.customer.name + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
          "Created at": {
            field: "works",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" +
                    val.created_at +
                    "</td></tr>" +
                    "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.created_at + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
          Status: {
            field: "works",
            callback: (value) => {
              let finalVal = "<table><tbody>";
              value.forEach((val, index) => {
                if (index == value.length - 1) {
                  finalVal +=
                    "<tr><td>" + val.status + "</td></tr>" + "</tbody></table>";
                } else {
                  finalVal += "<tr><td>" + val.status + "</td></tr>";
                }
              });
              return finalVal;
            },
          },
        },
      },
    };
  },

  computed: {
    calculaterAll() {
      var amount = Number(this.calculater.amount.replace(/\D/g, ""));
      const num = (amount * this.calculater.mulit) / this.calculater.divide;
      return parseFloat(num.toFixed()).toLocaleString();
    },
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        var userType = JSON.parse(this.$store.state.usertype) || null;
        if (
          userType.includes("superadmin") ||
          (userType.includes("company_actions") &&
            userType.includes("confirm_company_actions"))
        ) {
          if (this.companySearch == true) {
            return [
              {
                text: "#",
                value: "index",
                sortable: false,
                align: "center",
                width: 10,
              },
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Enterprise Account",
                value: "account.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Confirm",
                value: "confirm",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Control",
                value: "actions",
                sortable: false,
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 100,
              },
            ];
          } else {
            return [
              {
                text: "#",
                value: "index",
                align: "center",
                sortable: false,
                width: 50,
              },
              {
                text: "حدد",
                value: "selected",
                align: "center",
                sortable: false,
                width: 55,
              },
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Text Number",
                value: "companyLength",
                align: "center",
                sortable: false,
                width: 100,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Confirmed",
                value: "confirm",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Control",
                value: "actions",
                sortable: false,
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 100,
              },
            ];
          }
        } else if (!userType.includes("confirm_company_actions")) {
          if (this.companySearch == true) {
            return [
              {
                text: "#",
                value: "index",
                sortable: false,
                align: "center",
                width: 10,
              },
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Enterprise Account",
                value: "account.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Confirm",
                value: "confirm",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
            ];
          } else {
            return [
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
            ];
          }
        } else {
          if (this.companySearch == true) {
            return [
              {
                text: "#",
                value: "index",
                sortable: false,
                align: "center",
                width: 10,
              },
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Enterprise Account",
                value: "account.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },
              {
                text: "Control",
                value: "actions",
                sortable: false,
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 100,
              },
            ];
          } else {
            return [
              {
                text: " Total Amount ",
                value: "paid",
                align: "center",
                sortable: false,
                width: 200,
              },
              {
                text: " Company Name",
                value: "company.name",
                align: "center",
                width: 180,
              },
              {
                text: " Client Name",
                value: "customer.name",
                align: "center",
                width: 200,
              },
              {
                text: "Created at",
                value: "created_at",
                align: "center",
                sortable: false,
                width: 120,
              },
              {
                text: "Status",
                value: "status",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 120,
              },
              {
                text: "PDF File ",
                value: "pdf_file",
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                sortable: false,
                width: 100,
              },

              {
                text: "Control",
                value: "actions",
                sortable: false,
                align: "center",
                class: "showOnPrint",
                cellClass: "showOnPrint",
                width: 100,
              },
            ];
          }
        }
      }
    },
    headers_amount() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            value: "index",
            sortable: false,
            align: "center",
            width: 10,
          },
          {
            text: "اسم الموظف",
            value: "employee",
            align: "center",
          },
          {
            text: "اجمالي المحدد",
            value: "total_amount",
            align: "center",
          },
          {
            text: "ريت العميل",
            value: "client_rate",
            align: "center",
          },
          {
            text: "ريت البنك",
            value: "bank_rate",
            align: "center",
          },
          {
            text: "الفرق",
            value: "difference",
            align: "center",
          },
          {
            text: "تفاصيل المعاملات",
            value: "details",
            align: "center",
          },
          {
            text: "تأكيد",
            value: "confirm",
            align: "center",
          },
          // {
          //   text: "حذف",
          //   value: "actions",
          //   sortable: false,
          //   align: "center",
          //   width: 100,
          // },
        ];
      }
    },
    rowsWithTotalPaid() {
    return this.rows.map(row => {
      const totalPaid = row.works.reduce(
        (sum, work) => sum + Number(work.paid || 0),
        0
      );

      return {
        ...row,
        totalPaid
      };
    });
  }

  },

  methods: {
    handleScroll() {
      if (window.scrollY > 300) {
        this.showScrollTop = true;
      } else {
        this.showScrollTop = false;
      }
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    scrollToEnterprise(id) {
      this.activeTargetId = id;
      this.rows.forEach((row) => {
        if (row.works && row.works.length > 0) {
          this.$set(this.collapsedTables, row.id, row.id !== id);
        }
      });

      setTimeout(() => {
        const element = document.getElementById('enterprise-' + id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    },
    toggleTableCollapse(itemId) {
      const item = this.rows.find(row => row.id === itemId);
      if (item && item.works && item.works.length > 0) {
        this.$set(this.collapsedTables, itemId, !this.collapsedTables[itemId]);
      }
    },
    getTableItems(item) {
      if (!item.works) return [];
      if (item.works.length <= 0) return item.works;
      if (this.collapsedTables[item.id]) {
        return item.works.slice(0, 0);
      }
      return item.works;
    },
    columnClick(slotData) {
      const i = slotData.index;
      const indexExpanded = this.expanded.findIndex((i) => i === slotData.item);
      if (indexExpanded > -1) {
        this.expanded.splice(indexExpanded, 1);
      } else {
        this.expanded = [slotData.item];
      }
    },
    isSelected(item) {
      return this.selected.some((selected) => selected.id === item.id);
    },
    isAllSelected(items) {
      return items.length > 0 && items.every((item) => this.isSelected(item));
    },
    toggleSelect(item) {
      // if (this.singleSelect) {
      //   this.selected = [item];
      //   return;
      // }

      // const index = this.selected.findIndex(
      //   (selected) => selected.id === item.id
      // );
      // if (index > -1) {
      //   this.selected.splice(index, 1);
      // } else {
      //   this.selected.push(item);
      // }
      this.$axios({
        method: "POST",
        url: `client/company_work/save/${item.id}`,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: "تم الحفظ بنجاح",
            position: "topRight",
          });
          item.is_saved = !item.is_saved;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
        });
    },
    toggleSelectAll(items) {
      if (this.singleSelect) {
        this.selected = items.length ? [items[0]] : [];
        return;
      }

      if (this.isAllSelected(items)) {
        this.selected = this.selected.filter(
          (selected) => !items.some((item) => item.id === selected.id)
        );
      } else {
        const selectedIds = this.selected.map((item) => item.id);
        items.forEach((item) => {
          if (!selectedIds.includes(item.id)) {
            this.selected.push(item);
          }
        });
      }
    },

    // ... other methods
    addToRecords() {
      const newRecord = {
        id: Date.now(), // Generate a unique ID
        employee: "Current User", // Replace with actual user if available
        total_amount: parseFloat(this.data.totalAmount),
        client_rate: parseFloat(this.data.client_rate),
        bank_rate: parseFloat(this.data.bank_rate),
        difference: Math.trunc(this.data.subtraction * 100) / 100,
      };
      // // Add the new record to the beginning of the array
      this.last_amount.unshift(newRecord);
      // // Optionally, you can clear the form after submission
      // this.resetForm();
      // Show success message (optional)
      this.$iziToast.success({
        timeout: 2000,
        message: "تم اضافة السجل بنجاح",
        position: "topRight",
      });
    },

    // generate pdf
    generateReport(companyData) {
      document.title = companyData.company.name;
      this.pdfContent.fileName = companyData.company.name;
      this.pdfContent.enterprice = companyData.account.name;
      this.pdfContent.enterpriseRate = companyData.enterprise_rate;
      this.pdfContent.clientName = companyData.customer.name;
      this.pdfContent.country = companyData.company.country.name_ar;
      this.pdfContent.address = companyData.company.address;
      this.pdfContent.iban = companyData.company.account_number;
      this.pdfContent.refNum = companyData.reference;
      this.pdfContent.swift = companyData.company.swift_number;
      this.pdfContent.bankName = companyData.company.bank.name;
      this.pdfContent.products = companyData.company.products[0].name;
      this.pdfContent.amount = " SAR " + companyData.paid;
      this.pdfContent.enterpriseTotal =
        " SAR " + Number(companyData.enterprise_total).toLocaleString();
      this.pdfContent.created_at = companyData.created_at;
      this.pdfContent.status = companyData.status;
      setTimeout(() => {
        var iframePrint = document.querySelector(".iframePrint");
        var iframeHead = document.head.innerHTML;
        var printContents = document.querySelector(".pdf-print").innerHTML;
        iframePrint.contentWindow.document.write(iframeHead + printContents);
        setTimeout(() => {
          window.frames["printf"].print();
          iframePrint.contentWindow.document.close();
          document.title = "Golden Eyes";
        }, 500);
      }, 500);
    },
    calculate(amount) {
      this.showCalculater = !this.showCalculater;
      var money = Number(amount);
      this.calculater.amount = parseFloat(money.toFixed()).toLocaleString();
    },
    // searchTable
    searchTable(items) {
      if (items.company) {
        this.companySearch = true;
      } else {
        this.companySearch = false;
      }
      this.rows = [];
      this.allCalcItems = [];
      this.searchItems = items;
      this.searchCompany = items.company;
      this.setRows();
    },
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/debits/add" });
    },
    showItem(item) {
      this.dialogShow = true;
      this.itemToShow = item;
    },
    editItem(item) {
      this.$router.push({ path: "/companyAction/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.loadingBtnDialog = true;
      this.$axios({
        method: "DELETE",
        url: `client/company_work/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.loadingBtnDialog = false;
          this.setRows();
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "topRight",
          });
          this.$store.dispatch("getTranshState");
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
        });
    },
    // ==================== End CRUD ====================
    acceptCompany(id) {
      this.lodaing = true;
      this.$axios({
        method: "POST",
        url: "client/company_work/accept_company_work/" + id,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: "تأكيد بنجاح",
            position: "topRight",
          });
          this.setRows();
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
          this.btnIsLoading = false;
        });
    },
    rejectCompany(id) {
      this.lodaing = true;
      this.$axios({
        method: "POST",
        url: "client/company_work/refuse_company_work/" + id,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: "مرفوض بنجاح",
            position: "topRight",
          });
          this.setRows();
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
          this.btnIsLoading = false;
          this.lodaing = false;
        });
    },
    // Set Rows
    setRows() {
      this.lodaing = true;
      this.allWorks = [];
      this.$axios({
        method: "GET",
        url: "client/company_work/enterprise",
        params: {
          enterprise: this.searchItems ? this.searchItems.enterprice : "",
          customer: this.searchItems ? this.searchItems.username : "",
          company_id: this.searchItems ? this.searchItems.company : "",
          from_date: this.searchItems ? this.searchItems.from : "",
          to_date: this.searchItems ? this.searchItems.to : "",
        },
      })
        .then((res) => {
          this.rows = res.data.data;
          this.rows.forEach((ele) => {
            ele.works.forEach((mainEle) => {
              this.allWorks.push(mainEle);
              this.allWorks.forEach((subEle) => {
                if (mainEle.id == subEle.id) {
                  mainEle["indexNum"] = this.allWorks.indexOf(subEle, 0) + 1;
                }
              });
            });
            this.$set(ele, "totalPerClient", 0);
            this.$set(ele, "itemsToSum", []);
          });
          this.table_length = this.rows.length;
          this.excelData.items = this.rows;
          this.lodaing = false;
        })
        .catch((err) => {
          this.lodaing = false;
        });
    },
    //Total Amount
    totalAmount(ele, mainItem) {
      const indexExpanded = this.allCalcItems.findIndex((i) => i.id === ele.id);
      //  all total
      if (indexExpanded > -1) {
        this.allCalcItems.splice(indexExpanded, 1);
        this.calcResult -= Number(ele.paid);
      } else {
        this.allCalcItems.push(ele);
        this.calcResult += Number(ele.paid);
      }
      // client total

      const found = mainItem.itemsToSum.find((el) => el.id == ele.id);
      if (found) {
        mainItem.itemsToSum = mainItem.itemsToSum.filter(
          (el) => el.id != found.id
        );
        let total = 0;
        mainItem.itemsToSum.map((el) => (total += +el.paid));
        mainItem.totalPerClient = total;
      } else {
        mainItem.itemsToSum.push(ele);
        let total = 0;
        mainItem.itemsToSum.map((el) => (total += +el.paid));
        mainItem.totalPerClient = total;
      }
    },
  },

  watch: {
    calcResult(newValue) {
      if (newValue) {
        this.data.totalAmount = newValue;
        this.data.subtraction =
          Math.trunc(((this.data.client_rate - this.data.bank_rate) * this.calcResult) * 100) / 100;
      }
    },
    "data.client_rate"(newValue) {
      if (newValue && this.data.bank_rate) {
        this.data.subtraction =
          Math.trunc(((newValue - this.data.bank_rate) * this.calcResult) * 100) / 100;
      }

      if (!this.data.client_rate) {
        this.data.subtraction = 0;
      }
    },
    "data.bank_rate"(newValue) {
      if (newValue && this.data.client_rate) {
        this.data.subtraction =
          Math.trunc(((this.data.client_rate - newValue) * this.calcResult) * 100) / 100;
      }

      if (!this.data.bank_rate) {
        this.data.subtraction = 0;
      }
    },
  },

  // ======= hooks
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // permisions
    var userType = JSON.parse(this.$store.state.usertype) || null;
    if (
      !userType.includes("superadmin") &&
      !userType.includes("company_actions") &&
      !userType.includes("confirm_company_actions")
    ) {
      this.$router.push("/");
    }
  },
};
</script>

<style lang="scss" scoped>
.check_style {
  .v-icon {
    color: #6890c6 !important;
  }
}

// Simple and Creative Info Pill Animation
.info-pill {
  position: relative;
  overflow: hidden;
  animation: slideInBounce 0.6s ease-out;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.5),
      transparent
    );
    animation: shineSweep 3s ease-in-out infinite;
  }

  p {
    position: relative;
    z-index: 1;
    margin-bottom: 0;
  }

  span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    animation: numberPulse 2s ease-in-out infinite;
    transition: all 0.3s ease;

    i {
      animation: coinSpin 3s ease-in-out infinite;
      transition: transform 0.3s ease;
    }

    &:hover i {
      transform: rotate(360deg) scale(1.2);
    }

    &.redColor {
      animation: numberPulseRed 1.5s ease-in-out infinite;

      i {
        animation: coinSpinRed 2s ease-in-out infinite;
      }
    }
  }
}

// Animations
@keyframes slideInBounce {
  0% {
    opacity: 0;
    transform: translateY(-20px) scale(0.9);
  }
  60% {
    transform: translateY(5px) scale(1.02);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes pulseGlow {
  0%,
  100% {
    box-shadow: 0 4px 15px rgba(99, 102, 241, 0.2);
  }
  50% {
    box-shadow: 0 6px 25px rgba(99, 102, 241, 0.4);
  }
}

@keyframes shineSweep {
  0% {
    left: -100%;
  }
  50% {
    left: 100%;
  }
  100% {
    left: 100%;
  }
}

@keyframes numberPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes numberPulseRed {
  0%,
  100% {
    transform: scale(1);
    filter: brightness(0.9);
  }
  50% {
    transform: scale(1.08);
    filter: brightness(1.25);
  }
}

@keyframes coinSpin {
  0%,
  100% {
    transform: rotate(0deg) scale(1);
  }
  25% {
    transform: rotate(-10deg) scale(1.1);
  }
  75% {
    transform: rotate(10deg) scale(1.1);
  }
}

@keyframes coinSpinRed {
  0%,
  100% {
    transform: rotate(0deg) scale(1);
  }
  25% {
    transform: rotate(-15deg) scale(1.15);
  }
  75% {
    transform: rotate(15deg) scale(1.15);
  }
}

.equation-wrapper .equation-content {
  background-color: #e3f2fd;
  padding: 10px 20px;
  border-radius: 10px;
  form {
    display: flex;
    align-items: center;
    gap: 15px;
    .rate_calc {
      display: flex;
      align-items: center;
      gap: 15px;
    }
  }
}

.collapse-icon {
  cursor: pointer;
  font-size: 12px;
  color: #fff;
  background-color: #1F467A;
  transition: all 0.3s ease;
  padding: 6px !important;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px !important;
  height: 26px !important;
  i{
    color: #fff;
    font-size: 18px;
  }

  &:hover {
    background-color: #5981B6;
    color: #1F467A;
    transform: scale(1.1);
  }

  &.expanded {
    transform: rotate(0deg);
  }

  &.collapsed {
    transform: rotate(-90deg);
  }

  &:active {
    transform: scale(0.95);
  }
}

.no-data-collapsed {
  display: flex;
  justify-content: center;
  gap: 10px;
  p {
    font-size: 16px;
    font-weight: 500;
  }
}
.completed {
  color: #080;
}
.pending {
  color: #525e6e;
}
.pending_red {
  color: #f00;
}

/* Return to top button */
.return-to-top {
  position: fixed;
  bottom: 35px;
  right: 14%;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1F467A, #3967a5);
  color: white;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(31, 70, 122, 0.4);
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.return-to-top:hover {
  transform: translateY(-5px) scale(1.1);
  box-shadow: 0 8px 20px rgba(31, 70, 122, 0.6);
  background: linear-gradient(135deg, #3967a5, #1F467A);
}

.return-to-top i {
  transition: transform 0.3s ease;
}

.return-to-top:hover i {
  animation: floatingIcon 1.5s infinite ease-in-out;
}

@keyframes floatingIcon {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}

.fade-bounce-enter-active, .fade-bounce-leave-active {
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.fade-bounce-enter, .fade-bounce-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.5);
}

.active-enterprise-bg {
  background-color: #e3e7ee9e !important;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.active-enterprise-bg .theme--light.v-data-table{
    background-color: transparent !important;
}

</style>
